import { ref, readonly } from "vue";
import { useUser } from "@/composables/user";
import { useAnonymousIdentifier } from "@/composables/anonymousIdentifier.client";
import { CartStatus } from "@/services/marketplace/cart/cartTypes";
import { fetchCartStatus } from "@/services/marketplace/cart/cartApi";

const CheckInterval = 30000;

const status = ref<CartStatus>(CartStatus.Empty);
const isLoading = ref(false);
let timer: ReturnType<typeof setInterval> | undefined = undefined;

export const useCartStatus = () => {
  const { isUserLoggedIn } = useUser();
  const { getIdentifier } = useAnonymousIdentifier();

  const refresh = async (): Promise<void> => {
    isLoading.value = true;
    const anonymousIdentifier = isUserLoggedIn.value ? undefined : getIdentifier();
    status.value = await fetchCartStatus(anonymousIdentifier);
    isLoading.value = false;
  };

  const startAutoRefresh = (): void => {
    if (timer !== undefined) return;
    refresh();
    timer = setInterval(() => refresh(), CheckInterval);
  };

  const stopAutoRefresh = (): void => {
    clearInterval(timer);
    timer = undefined;
  };

  return {
    status: readonly(status),
    isLoading: readonly(isLoading),
    refresh,
    startAutoRefresh,
    stopAutoRefresh,
  };
};
